// src/data/dummyData.js - Complete Dummy Data for CircleHub Admin

export const dashboardStats = {
  totalUsers: 2847,
  totalGroups: 156,
  activeSessions: 23,
  totalFiles: 1289,
  aiUsage: 567,
  usersChange: 12.5,
  groupsChange: 8.3,
  sessionsChange: -3.2,
  filesChange: 15.7,
  aiChange: 22.1
};

export const users = [
  {
    id: 1,
    name: "Ali Khan",
    email: "ali.khan@example.com",
    role: "Student",
    status: "active",
    domain: "Computer Science",
    joinedDate: "2024-01-15",
    lastActive: "2 hours ago",
    avatar: null
  },
  {
    id: 2,
    name: "Fatima Ahmed",
    email: "fatima@example.com",
    role: "Tutor",
    status: "active",
    domain: "Business",
    joinedDate: "2024-02-20",
    lastActive: "1 day ago",
    avatar: null
  },
  {
    id: 3,
    name: "Hassan Malik",
    email: "hassan.m@example.com",
    role: "Student",
    status: "inactive",
    domain: "IT",
    joinedDate: "2024-03-10",
    lastActive: "5 days ago",
    avatar: null
  },
  {
    id: 4,
    name: "Ayesha Siddiqui",
    email: "ayesha.s@example.com",
    role: "Student",
    status: "active",
    domain: "Computer Science",
    joinedDate: "2024-01-25",
    lastActive: "30 minutes ago",
    avatar: null
  },
  {
    id: 5,
    name: "Usman Raza",
    email: "usman.r@example.com",
    role: "Tutor",
    status: "blocked",
    domain: "Engineering",
    joinedDate: "2023-12-05",
    lastActive: "2 weeks ago",
    avatar: null
  }
];

export const studyGroups = [
  {
    id: 1,
    name: "Advanced React Development",
    domain: "Computer Science",
    members: 45,
    status: "approved",
    createdBy: "Ali Khan",
    createdDate: "2024-01-20",
    description: "Learn advanced React concepts"
  },
  {
    id: 2,
    name: "Business Analytics 101",
    domain: "Business",
    members: 32,
    status: "pending",
    createdBy: "Fatima Ahmed",
    createdDate: "2024-02-15",
    description: "Introduction to business analytics"
  },
  {
    id: 3,
    name: "Network Security Group",
    domain: "IT",
    members: 28,
    status: "approved",
    createdBy: "Hassan Malik",
    createdDate: "2024-03-01",
    description: "Cybersecurity fundamentals"
  },
  {
    id: 4,
    name: "Data Structures Study Circle",
    domain: "Computer Science",
    members: 56,
    status: "approved",
    createdBy: "Ayesha Siddiqui",
    createdDate: "2024-01-10",
    description: "Master data structures and algorithms"
  },
  {
    id: 5,
    name: "Machine Learning Basics",
    domain: "Computer Science",
    members: 38,
    status: "rejected",
    createdBy: "Usman Raza",
    createdDate: "2024-02-28",
    description: "Introduction to ML concepts"
  }
];

export const liveSessions = [
  {
    id: 1,
    title: "React Hooks Deep Dive",
    tutor: "Ali Khan",
    domain: "Computer Science",
    status: "live",
    participants: 23,
    scheduledTime: "2024-12-29 14:00",
    duration: "2 hours"
  },
  {
    id: 2,
    title: "Financial Management Basics",
    tutor: "Fatima Ahmed",
    domain: "Business",
    status: "scheduled",
    participants: 15,
    scheduledTime: "2024-12-30 10:00",
    duration: "1.5 hours"
  },
  {
    id: 3,
    title: "Cybersecurity Workshop",
    tutor: "Hassan Malik",
    domain: "IT",
    status: "completed",
    participants: 28,
    scheduledTime: "2024-12-28 16:00",
    duration: "3 hours"
  }
];

export const filesData = [
  {
    id: 1,
    name: "React_Complete_Guide.pdf",
    uploadedBy: "Ali Khan",
    size: "5.2 MB",
    uploadDate: "2024-12-20",
    status: "approved",
    downloads: 145,
    type: "pdf"
  },
  {
    id: 2,
    name: "Business_Plan_Template.docx",
    uploadedBy: "Fatima Ahmed",
    size: "2.1 MB",
    uploadDate: "2024-12-22",
    status: "pending",
    downloads: 23,
    type: "document"
  },
  {
    id: 3,
    name: "Network_Security_Notes.pdf",
    uploadedBy: "Hassan Malik",
    size: "8.5 MB",
    uploadDate: "2024-12-15",
    status: "approved",
    downloads: 89,
    type: "pdf"
  }
];

export const domains = [
  { id: 1, name: "Computer Science", studyGroups: 45, students: 523, tutors: 12 },
  { id: 2, name: "Business", studyGroups: 32, students: 412, tutors: 8 },
  { id: 3, name: "IT", studyGroups: 28, students: 356, tutors: 10 },
  { id: 4, name: "Engineering", studyGroups: 38, students: 489, tutors: 15 },
  { id: 5, name: "Medical", studyGroups: 21, students: 298, tutors: 7 }
];

export const quizzes = [
  {
    id: 1,
    title: "React Fundamentals Quiz",
    domain: "Computer Science",
    questions: 20,
    duration: "30 minutes",
    attempts: 156,
    averageScore: 78,
    createdDate: "2024-12-10"
  },
  {
    id: 2,
    title: "Business Ethics Assessment",
    domain: "Business",
    questions: 15,
    duration: "20 minutes",
    attempts: 89,
    averageScore: 82,
    createdDate: "2024-12-15"
  }
];

export const notifications = [
  {
    id: 1,
    title: "New User Registration",
    message: "Ali Khan registered as a student",
    type: "info",
    time: "2 hours ago",
    read: false
  },
  {
    id: 2,
    title: "Group Pending Approval",
    message: "Business Analytics 101 needs review",
    type: "warning",
    time: "5 hours ago",
    read: false
  },
  {
    id: 3,
    title: "System Update",
    message: "Platform updated successfully",
    type: "success",
    time: "1 day ago",
    read: true
  }
];

export const recentActivities = [
  {
    id: 1,
    user: "Ali Khan",
    action: "uploaded a new file",
    target: "React_Complete_Guide.pdf",
    time: "2 hours ago",
    icon: "📄"
  },
  {
    id: 2,
    user: "Fatima Ahmed",
    action: "created a study group",
    target: "Business Analytics 101",
    time: "5 hours ago",
    icon: "👥"
  },
  {
    id: 3,
    user: "Hassan Malik",
    action: "completed a live session",
    target: "Cybersecurity Workshop",
    time: "1 day ago",
    icon: "🎥"
  },
  {
    id: 4,
    user: "Ayesha Siddiqui",
    action: "submitted a quiz",
    target: "React Fundamentals Quiz",
    time: "2 days ago",
    icon: "✅"
  }
];

export const chartData = {
  userGrowth: [
    { month: 'Jan', users: 1200 },
    { month: 'Feb', users: 1450 },
    { month: 'Mar', users: 1680 },
    { month: 'Apr', users: 1890 },
    { month: 'May', users: 2100 },
    { month: 'Jun', users: 2340 },
    { month: 'Jul', users: 2580 },
    { month: 'Aug', users: 2847 }
  ],
  domainDistribution: [
    { name: 'Computer Science', value: 523, color: '#0ea5e9' },
    { name: 'Business', value: 412, color: '#10b981' },
    { name: 'IT', value: 356, color: '#f59e0b' },
    { name: 'Engineering', value: 489, color: '#ef4444' },
    { name: 'Medical', value: 298, color: '#8b5cf6' }
  ]
};

export const leaderboard = [
  {
    rank: 1,
    name: "Ali Khan",
    domain: "Computer Science",
    points: 2450,
    avatar: null
  },
  {
    rank: 2,
    name: "Ayesha Siddiqui",
    domain: "Computer Science",
    points: 2280,
    avatar: null
  },
  {
    rank: 3,
    name: "Fatima Ahmed",
    domain: "Business",
    points: 2150,
    avatar: null
  },
  {
    rank: 4,
    name: "Hassan Malik",
    domain: "IT",
    points: 1980,
    avatar: null
  },
  {
    rank: 5,
    name: "Usman Raza",
    domain: "Engineering",
    points: 1850,
    avatar: null
  }
];